export const schemePreview = {
  "applyAndTry": '申请试用',
  "emptyMessage": "暂无数据"
}
